import { css, useTheme } from "@emotion/react";
import React from "react";
import { useParams } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { Flex } from "../../base";
import { appSelector } from "../../modules/apps";
import { LoadingOrb } from "../LoadingBlock";
import Graphs from "./Graph";
import useGraphData from "./useGraphData";

const Loading = () => (
  <Flex
    center
    align="center"
    css={css`
      width: 100%;
      height: 100%;
      min-height: 30vh;
    `}
  >
    <LoadingOrb size={96} />
  </Flex>
);

const AppGraph = ({ appId }) => {
  const app = useRecoilValue(appSelector(appId));
  const [data, hasValues, loading] = useGraphData(
    "apps",
    app.partition.substr(2)
  );

  if (loading) {
    return <Loading />;
  }
  if (!hasValues) {
    return null;
  }

  return <Graphs color={app.color} data={data} />;
};

const AddressGraph = ({ address }) => {
  const { color } = useTheme();
  const [data, hasValues, loading] = useGraphData(
    "accounts",
    address.substr(2)
  );

  if (loading) {
    return <Loading />;
  }
  if (!hasValues) {
    return null;
  }

  return <Graphs color={color.highlight} data={data} />;
};

const NetworkGraph = () => {
  const { color } = useTheme();
  const [data, hasValues, loading] = useGraphData("global", "amp");

  if (loading) {
    return <Loading />;
  }

  if (!hasValues) {
    return null;
  }

  return <Graphs color={color.highlight} data={data} />;
};

const GraphSwitcher = () => {
  const { type: slugType, slug } = useParams<{ type: string; slug: string }>();

  return slugType === "app" ? (
    <AppGraph key={slug} appId={slug} />
  ) : slugType === "address" ? (
    <AddressGraph key={slug} address={slug} />
  ) : (
    <NetworkGraph key="network" />
  );
};

export default GraphSwitcher;
